import type {
	ICPSvgIconTypes,
	ICPTableHeadColActiveSort,
	ICPTableViewSettingsColumn,
	ICPTagPropTypes
} from '~/portal/components/base'
import { PaginationMode } from '~/portal/components/base'

export enum ECP_PROJECTS_TABLE_KEYS {
	Project_name = 'Name des Projekts',
	Id = 'ID',
	Author = 'Autorin',
	Total_progress = '%',
	Phase = 'Phase',
	Period = 'Periode',
	PMs = 'PMs',
	Comment = 'Interner Kommentar',
	Deadline = 'Frist',
	Last_activity = 'Letzte Aktivität',
	Documents = 'Dokumente',
	Documents_updated = 'Documents_updated',
	Doc_status = 'Status',
	Status_az = 'Status (AZ)',
	Status_ke = 'Status (KE)',
	Indicators = 'Indikator',
	Sub_phase = 'Subphase',
	Company = 'Firma',
	Client_admin = 'Admin',
	Project_member = 'Verwaltet von',
	Applicant = 'Auftraggeber',
	Certificate_holder = 'Zertifikatsinhaber',
	Grid_operator = 'Netzbetreiber',
	Voltage_level = 'Spannungsebene',
	Type = 'Typ',
	Plan = 'Verfahren',
	Public_comment = 'Öffentlicher Kommentar',
	Creation_date = 'Erstellungsdatum',
	Plant_certificate_date = 'Erstellungsdatum des Anlagenzertifikats',
	Plant_certificate_validity = 'Gültigkeitsdauer des Anlagenzertifikats',
	Ibn_date = 'IBN-Datum',
	Extension_of_validity = 'Verlängerung der Gültigkeit',
	Conformity_assessment_date = 'Erstellungsdatum der Konformitätsprüfung',
	City = 'Stadt',
	Street = 'Straße',
	Hallway = 'Flur',
	District = 'Bezirk',
	Index = 'Postleitzahl',
	Recent_activity_user = 'Benutzer, der die letzte ' +
		'Aktivität durchgeführt hat',
	Hints = 'Info',
	RowBg = 'rowBg',
	RowId = 'rowId',
	RowPhase = 'rowPhase',
	DisabledAction = 'disabledAction',
	ActiveReminders = 'ActiveEmailReminders'
}

export enum ECP_PROJECTS_VIEW_COLUMNS {
	Name = 'name',
	Indicators = 'indicators',
	Id = 'id',
	Period = 'period',
	Status_az = 'status_az',
	Status_ke = 'status_ke',
	Phase = 'phase',
	Sub_phase = 'sub_phase',
	Percentage = 'percentage',
	Pms = 'pms',
	Documents = 'documents',
	Company = 'company',
	Client_admin = 'client_admin',
	Project_member = 'project_member',
	Author = 'author',
	Applicant = 'applicant',
	Certificate_holder = 'certificate_holder',
	Grid_operator = 'grid_operator',
	Voltage_level = 'voltage_level',
	Type = 'type',
	Plan = 'plan',
	Comment = 'comment',
	Internal_comment = 'internal_comment',
	Deadline = 'deadline',
	Creation_date = 'creation_date',
	Plant_certificate_date = 'creation_date_of_plant_certificate',
	Plant_certificate_validity = 'validity_of_plant_certificate',
	Ibn_date = 'ibn_date',
	Extension_of_validity = 'extension_of_validity',
	Conformity_assessment_date = 'creation_date_of_conformity_assessment',
	City = 'city',
	Street = 'street',
	Hallway = 'hallway',
	District = 'district',
	Index = 'index',
	Recent_activity = 'recent_activity',
	Recent_activity_user = 'recent_activity_user'
}

export const PROJECTS_TABLE_VIEW_COLUMNS: ICPTableViewSettingsColumn[] = [
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Name,
		label: 'Name des Projekts',
		fixed: true,
		visible: true,
		locked: true
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Indicators,
		label: 'Indikator',
		fixed: true,
		visible: true,
		locked: true
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Id,
		label: 'ID',
		fixed: true,
		visible: true,
		locked: true
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Period,
		label: 'Periode',
		fixed: true,
		visible: true,
		locked: true
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Status_az,
		label: 'Status (AZ)',
		fixed: true,
		visible: true
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Status_ke,
		label: 'Status (KE)',
		fixed: true,
		visible: true
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Phase,
		label: 'Phase',
		fixed: false,
		visible: false
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Sub_phase,
		label: 'Subphase',
		fixed: false,
		visible: false
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Percentage,
		label: '%',
		fixed: false,
		visible: false
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Pms,
		label: 'PMs',
		fixed: false,
		visible: true
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Documents,
		label: 'Dokumente',
		fixed: false,
		visible: true
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Company,
		label: 'Firma',
		fixed: false,
		visible: false
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Client_admin,
		label: 'Admin',
		fixed: false,
		visible: false
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Project_member,
		label: 'Verwaltet von',
		fixed: false,
		visible: false
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Author,
		label: 'Autorin',
		fixed: false,
		visible: false
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Applicant,
		label: 'Auftraggeber',
		fixed: false,
		visible: false
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Certificate_holder,
		label: 'Zertifikatsinhaber',
		fixed: false,
		visible: false
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Grid_operator,
		label: 'Netzbetreiber',
		fixed: false,
		visible: false
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Voltage_level,
		label: 'Spannungsebene',
		fixed: false,
		visible: false
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Type,
		label: 'Typ',
		fixed: false,
		visible: false
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Plan,
		label: 'Verfahren',
		fixed: false,
		visible: false
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Comment,
		label: 'Öffentlicher Kommentar',
		fixed: false,
		visible: true
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Internal_comment,
		label: 'Interner Kommentar',
		fixed: false,
		visible: false
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Deadline,
		label: 'Frist',
		fixed: false,
		visible: true
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Creation_date,
		label: 'Erstellungsdatum',
		fixed: false,
		visible: false
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Plant_certificate_date,
		label: 'Erstellungsdatum des Anlagenzertifikats',
		fixed: false,
		visible: false
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Plant_certificate_validity,
		label: 'Gültigkeitsdauer des Anlagenzertifikats',
		fixed: false,
		visible: false
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Ibn_date,
		label: 'IBN-Datum',
		fixed: false,
		visible: false
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Extension_of_validity,
		label: 'Verlängerung der Gültigkeit',
		fixed: false,
		visible: false
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Conformity_assessment_date,
		label: 'Erstellungsdatum der Konformitätsprüfung',
		fixed: false,
		visible: false
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.City,
		label: 'Stadt',
		fixed: false,
		visible: false
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Street,
		label: 'Straße',
		fixed: false,
		visible: false
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Hallway,
		label: 'Flur',
		fixed: false,
		visible: false
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.District,
		label: 'Bezirk',
		fixed: false,
		visible: false
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Index,
		label: 'Postleitzahl',
		fixed: false,
		visible: false
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Recent_activity,
		label: 'Letzte Aktivität',
		fixed: false,
		visible: false
	},
	{
		key: ECP_PROJECTS_VIEW_COLUMNS.Recent_activity_user,
		label: 'Benutzer, der die letzte Aktivität durchgeführt hat',
		fixed: false,
		visible: false
	}
]

export const PROJECTS_FIXED_COLUMN_WIDTHS: Record<
	ECP_PROJECTS_VIEW_COLUMNS,
	number
> = {
	[ECP_PROJECTS_VIEW_COLUMNS.Name]: 280,
	[ECP_PROJECTS_VIEW_COLUMNS.Indicators]: 140,
	[ECP_PROJECTS_VIEW_COLUMNS.Id]: 90,
	[ECP_PROJECTS_VIEW_COLUMNS.Period]: 150,
	[ECP_PROJECTS_VIEW_COLUMNS.Status_az]: 150,
	[ECP_PROJECTS_VIEW_COLUMNS.Status_ke]: 150,
	[ECP_PROJECTS_VIEW_COLUMNS.Phase]: 180,
	[ECP_PROJECTS_VIEW_COLUMNS.Sub_phase]: 180,
	[ECP_PROJECTS_VIEW_COLUMNS.Percentage]: 90,
	[ECP_PROJECTS_VIEW_COLUMNS.Pms]: 220,
	[ECP_PROJECTS_VIEW_COLUMNS.Documents]: 160,
	[ECP_PROJECTS_VIEW_COLUMNS.Company]: 200,
	[ECP_PROJECTS_VIEW_COLUMNS.Client_admin]: 200,
	[ECP_PROJECTS_VIEW_COLUMNS.Project_member]: 220,
	[ECP_PROJECTS_VIEW_COLUMNS.Author]: 180,
	[ECP_PROJECTS_VIEW_COLUMNS.Applicant]: 180,
	[ECP_PROJECTS_VIEW_COLUMNS.Certificate_holder]: 200,
	[ECP_PROJECTS_VIEW_COLUMNS.Grid_operator]: 200,
	[ECP_PROJECTS_VIEW_COLUMNS.Voltage_level]: 160,
	[ECP_PROJECTS_VIEW_COLUMNS.Type]: 90,
	[ECP_PROJECTS_VIEW_COLUMNS.Plan]: 120,
	[ECP_PROJECTS_VIEW_COLUMNS.Comment]: 240,
	[ECP_PROJECTS_VIEW_COLUMNS.Internal_comment]: 240,
	[ECP_PROJECTS_VIEW_COLUMNS.Deadline]: 130,
	[ECP_PROJECTS_VIEW_COLUMNS.Creation_date]: 150,
	[ECP_PROJECTS_VIEW_COLUMNS.Plant_certificate_date]: 180,
	[ECP_PROJECTS_VIEW_COLUMNS.Plant_certificate_validity]: 180,
	[ECP_PROJECTS_VIEW_COLUMNS.Ibn_date]: 150,
	[ECP_PROJECTS_VIEW_COLUMNS.Extension_of_validity]: 180,
	[ECP_PROJECTS_VIEW_COLUMNS.Conformity_assessment_date]: 180,
	[ECP_PROJECTS_VIEW_COLUMNS.City]: 150,
	[ECP_PROJECTS_VIEW_COLUMNS.Street]: 180,
	[ECP_PROJECTS_VIEW_COLUMNS.Hallway]: 120,
	[ECP_PROJECTS_VIEW_COLUMNS.District]: 150,
	[ECP_PROJECTS_VIEW_COLUMNS.Index]: 120,
	[ECP_PROJECTS_VIEW_COLUMNS.Recent_activity]: 160,
	[ECP_PROJECTS_VIEW_COLUMNS.Recent_activity_user]: 200
}

export const PROJECTS_COLUMN_MAX_WIDTHS: Record<
	ECP_PROJECTS_VIEW_COLUMNS,
	number
> = {
	[ECP_PROJECTS_VIEW_COLUMNS.Name]: 1200,
	[ECP_PROJECTS_VIEW_COLUMNS.Indicators]: 600,
	[ECP_PROJECTS_VIEW_COLUMNS.Id]: 400,
	[ECP_PROJECTS_VIEW_COLUMNS.Period]: 600,
	[ECP_PROJECTS_VIEW_COLUMNS.Status_az]: 600,
	[ECP_PROJECTS_VIEW_COLUMNS.Status_ke]: 600,
	[ECP_PROJECTS_VIEW_COLUMNS.Phase]: 800,
	[ECP_PROJECTS_VIEW_COLUMNS.Sub_phase]: 800,
	[ECP_PROJECTS_VIEW_COLUMNS.Percentage]: 400,
	[ECP_PROJECTS_VIEW_COLUMNS.Pms]: 1000,
	[ECP_PROJECTS_VIEW_COLUMNS.Documents]: 600,
	[ECP_PROJECTS_VIEW_COLUMNS.Company]: 1000,
	[ECP_PROJECTS_VIEW_COLUMNS.Client_admin]: 800,
	[ECP_PROJECTS_VIEW_COLUMNS.Project_member]: 1000,
	[ECP_PROJECTS_VIEW_COLUMNS.Author]: 800,
	[ECP_PROJECTS_VIEW_COLUMNS.Applicant]: 800,
	[ECP_PROJECTS_VIEW_COLUMNS.Certificate_holder]: 1000,
	[ECP_PROJECTS_VIEW_COLUMNS.Grid_operator]: 1000,
	[ECP_PROJECTS_VIEW_COLUMNS.Voltage_level]: 600,
	[ECP_PROJECTS_VIEW_COLUMNS.Type]: 400,
	[ECP_PROJECTS_VIEW_COLUMNS.Plan]: 600,
	[ECP_PROJECTS_VIEW_COLUMNS.Comment]: 1600,
	[ECP_PROJECTS_VIEW_COLUMNS.Internal_comment]: 1600,
	[ECP_PROJECTS_VIEW_COLUMNS.Deadline]: 500,
	[ECP_PROJECTS_VIEW_COLUMNS.Creation_date]: 500,
	[ECP_PROJECTS_VIEW_COLUMNS.Plant_certificate_date]: 600,
	[ECP_PROJECTS_VIEW_COLUMNS.Plant_certificate_validity]: 600,
	[ECP_PROJECTS_VIEW_COLUMNS.Ibn_date]: 500,
	[ECP_PROJECTS_VIEW_COLUMNS.Extension_of_validity]: 600,
	[ECP_PROJECTS_VIEW_COLUMNS.Conformity_assessment_date]: 600,
	[ECP_PROJECTS_VIEW_COLUMNS.City]: 800,
	[ECP_PROJECTS_VIEW_COLUMNS.Street]: 1000,
	[ECP_PROJECTS_VIEW_COLUMNS.Hallway]: 600,
	[ECP_PROJECTS_VIEW_COLUMNS.District]: 800,
	[ECP_PROJECTS_VIEW_COLUMNS.Index]: 500,
	[ECP_PROJECTS_VIEW_COLUMNS.Recent_activity]: 500,
	[ECP_PROJECTS_VIEW_COLUMNS.Recent_activity_user]: 800
}

export const PROJECTS_LIST_HELPER_FIELDS: string[] = [
	'indicators',
	'phase',
	'recent_activity'
]

export const PROJECTS_INDICATOR_FIELDS: string[] = [
	'indicators',
	'plan',
	'contain_new_saved_answers'
]

export const PROJECTS_VIEW_COLUMN_TO_TABLE_KEY: Record<
	ECP_PROJECTS_VIEW_COLUMNS,
	ECP_PROJECTS_TABLE_KEYS
> = {
	[ECP_PROJECTS_VIEW_COLUMNS.Name]: ECP_PROJECTS_TABLE_KEYS.Project_name,
	[ECP_PROJECTS_VIEW_COLUMNS.Indicators]: ECP_PROJECTS_TABLE_KEYS.Indicators,
	[ECP_PROJECTS_VIEW_COLUMNS.Id]: ECP_PROJECTS_TABLE_KEYS.Id,
	[ECP_PROJECTS_VIEW_COLUMNS.Period]: ECP_PROJECTS_TABLE_KEYS.Period,
	[ECP_PROJECTS_VIEW_COLUMNS.Status_az]: ECP_PROJECTS_TABLE_KEYS.Status_az,
	[ECP_PROJECTS_VIEW_COLUMNS.Status_ke]: ECP_PROJECTS_TABLE_KEYS.Status_ke,
	[ECP_PROJECTS_VIEW_COLUMNS.Phase]: ECP_PROJECTS_TABLE_KEYS.Phase,
	[ECP_PROJECTS_VIEW_COLUMNS.Sub_phase]: ECP_PROJECTS_TABLE_KEYS.Sub_phase,
	[ECP_PROJECTS_VIEW_COLUMNS.Percentage]:
		ECP_PROJECTS_TABLE_KEYS.Total_progress,
	[ECP_PROJECTS_VIEW_COLUMNS.Pms]: ECP_PROJECTS_TABLE_KEYS.PMs,
	[ECP_PROJECTS_VIEW_COLUMNS.Documents]: ECP_PROJECTS_TABLE_KEYS.Documents,
	[ECP_PROJECTS_VIEW_COLUMNS.Company]: ECP_PROJECTS_TABLE_KEYS.Company,
	[ECP_PROJECTS_VIEW_COLUMNS.Client_admin]:
		ECP_PROJECTS_TABLE_KEYS.Client_admin,
	[ECP_PROJECTS_VIEW_COLUMNS.Project_member]:
		ECP_PROJECTS_TABLE_KEYS.Project_member,
	[ECP_PROJECTS_VIEW_COLUMNS.Author]: ECP_PROJECTS_TABLE_KEYS.Author,
	[ECP_PROJECTS_VIEW_COLUMNS.Applicant]: ECP_PROJECTS_TABLE_KEYS.Applicant,
	[ECP_PROJECTS_VIEW_COLUMNS.Certificate_holder]:
		ECP_PROJECTS_TABLE_KEYS.Certificate_holder,
	[ECP_PROJECTS_VIEW_COLUMNS.Grid_operator]:
		ECP_PROJECTS_TABLE_KEYS.Grid_operator,
	[ECP_PROJECTS_VIEW_COLUMNS.Voltage_level]:
		ECP_PROJECTS_TABLE_KEYS.Voltage_level,
	[ECP_PROJECTS_VIEW_COLUMNS.Type]: ECP_PROJECTS_TABLE_KEYS.Type,
	[ECP_PROJECTS_VIEW_COLUMNS.Plan]: ECP_PROJECTS_TABLE_KEYS.Plan,
	[ECP_PROJECTS_VIEW_COLUMNS.Comment]: ECP_PROJECTS_TABLE_KEYS.Public_comment,
	[ECP_PROJECTS_VIEW_COLUMNS.Internal_comment]:
		ECP_PROJECTS_TABLE_KEYS.Comment,
	[ECP_PROJECTS_VIEW_COLUMNS.Deadline]: ECP_PROJECTS_TABLE_KEYS.Deadline,
	[ECP_PROJECTS_VIEW_COLUMNS.Creation_date]:
		ECP_PROJECTS_TABLE_KEYS.Creation_date,
	[ECP_PROJECTS_VIEW_COLUMNS.Plant_certificate_date]:
		ECP_PROJECTS_TABLE_KEYS.Plant_certificate_date,
	[ECP_PROJECTS_VIEW_COLUMNS.Plant_certificate_validity]:
		ECP_PROJECTS_TABLE_KEYS.Plant_certificate_validity,
	[ECP_PROJECTS_VIEW_COLUMNS.Ibn_date]: ECP_PROJECTS_TABLE_KEYS.Ibn_date,
	[ECP_PROJECTS_VIEW_COLUMNS.Extension_of_validity]:
		ECP_PROJECTS_TABLE_KEYS.Extension_of_validity,
	[ECP_PROJECTS_VIEW_COLUMNS.Conformity_assessment_date]:
		ECP_PROJECTS_TABLE_KEYS.Conformity_assessment_date,
	[ECP_PROJECTS_VIEW_COLUMNS.City]: ECP_PROJECTS_TABLE_KEYS.City,
	[ECP_PROJECTS_VIEW_COLUMNS.Street]: ECP_PROJECTS_TABLE_KEYS.Street,
	[ECP_PROJECTS_VIEW_COLUMNS.Hallway]: ECP_PROJECTS_TABLE_KEYS.Hallway,
	[ECP_PROJECTS_VIEW_COLUMNS.District]: ECP_PROJECTS_TABLE_KEYS.District,
	[ECP_PROJECTS_VIEW_COLUMNS.Index]: ECP_PROJECTS_TABLE_KEYS.Index,
	[ECP_PROJECTS_VIEW_COLUMNS.Recent_activity]:
		ECP_PROJECTS_TABLE_KEYS.Last_activity,
	[ECP_PROJECTS_VIEW_COLUMNS.Recent_activity_user]:
		ECP_PROJECTS_TABLE_KEYS.Recent_activity_user
}

export const PROJECTS_TABLE_KEY_TO_VIEW_COLUMN = Object.fromEntries(
	Object.entries(PROJECTS_VIEW_COLUMN_TO_TABLE_KEY).map(
		([column, tableKey]: [string, ECP_PROJECTS_TABLE_KEYS]) => [
			tableKey,
			column
		]
	)
) as Record<string, ECP_PROJECTS_VIEW_COLUMNS>

export enum ECP_PROJECTS_STATUS {
	Empty = 'Leer',
	Checked = 'Kontrolliert',
	Unchecked = 'Ungeprüft',
	Returned = 'Zurückgegeben',
	NotRelevant = 'Nicht relevant'
}

export enum ECP_PROJECTS_HINTS {
	Blocked = 'Blocked',
	Unpaid = 'Unpaid',
	Messages = 'Messages',
	HasUnsavedAnswers = 'HasUnsavedAnswers',
	ActiveEmailReminders = 'ActiveEmailReminders',
	Express = 'Express'
}

export type ICPProjectPeriodTag = {
	text: string
	color: ICPTagPropTypes['color']
	tooltip?: {
		phase: string
		period: string
		days: string
	}
}

export type TProjectsTableCellValue =
	| string
	| number
	| string[]
	| ECP_PROJECTS_STATUS
	| ECP_PROJECTS_HINTS[]
	| ICPProjectPeriodTag

export interface ICPProjectsTableItemTypes {
	[ECP_PROJECTS_TABLE_KEYS.Project_name]?:
		| string
		| {
				value: string
				components: {
					tooltip: {
						props: {
							text: string
						}
					}
					activator: {
						name: string
						props: ICPSvgIconTypes & {
							class: string
						}
					}
				}[]
		  }
	[ECP_PROJECTS_TABLE_KEYS.Id]?: number
	[ECP_PROJECTS_TABLE_KEYS.Author]?: string
	[ECP_PROJECTS_TABLE_KEYS.Total_progress]?: string
	[ECP_PROJECTS_TABLE_KEYS.Phase]?: string
	[ECP_PROJECTS_TABLE_KEYS.Period]?: ICPProjectPeriodTag | string
	[ECP_PROJECTS_TABLE_KEYS.PMs]?: string[]
	[ECP_PROJECTS_TABLE_KEYS.Comment]?: string
	[ECP_PROJECTS_TABLE_KEYS.Deadline]?: Date | string
	[ECP_PROJECTS_TABLE_KEYS.Last_activity]?: Date | string
	[ECP_PROJECTS_TABLE_KEYS.Documents]?: string
	[ECP_PROJECTS_TABLE_KEYS.Documents_updated]?: number
	[ECP_PROJECTS_TABLE_KEYS.Hints]?: ECP_PROJECTS_HINTS[]
	[ECP_PROJECTS_TABLE_KEYS.Doc_status]?: ECP_PROJECTS_STATUS
	[ECP_PROJECTS_TABLE_KEYS.Status_az]?: ECP_PROJECTS_STATUS | '-'
	[ECP_PROJECTS_TABLE_KEYS.Status_ke]?: ECP_PROJECTS_STATUS | '-'
	[ECP_PROJECTS_TABLE_KEYS.RowBg]?: string
	[ECP_PROJECTS_TABLE_KEYS.RowId]: number
	[ECP_PROJECTS_TABLE_KEYS.RowPhase]?: string
	[ECP_PROJECTS_TABLE_KEYS.Indicators]?: ECP_PROJECTS_HINTS[] | string
	[ECP_PROJECTS_TABLE_KEYS.Sub_phase]?: string
	[ECP_PROJECTS_TABLE_KEYS.Company]?: string
	[ECP_PROJECTS_TABLE_KEYS.Client_admin]?: string
	[ECP_PROJECTS_TABLE_KEYS.Project_member]?: string
	[ECP_PROJECTS_TABLE_KEYS.Applicant]?: string
	[ECP_PROJECTS_TABLE_KEYS.Certificate_holder]?: string
	[ECP_PROJECTS_TABLE_KEYS.Grid_operator]?: string
	[ECP_PROJECTS_TABLE_KEYS.Voltage_level]?: string
	[ECP_PROJECTS_TABLE_KEYS.Type]?: string
	[ECP_PROJECTS_TABLE_KEYS.Plan]?: string
	[ECP_PROJECTS_TABLE_KEYS.Public_comment]?: string
	[ECP_PROJECTS_TABLE_KEYS.Creation_date]?: string
	[ECP_PROJECTS_TABLE_KEYS.Plant_certificate_date]?: string
	[ECP_PROJECTS_TABLE_KEYS.Plant_certificate_validity]?: string
	[ECP_PROJECTS_TABLE_KEYS.Ibn_date]?: string
	[ECP_PROJECTS_TABLE_KEYS.Extension_of_validity]?: string
	[ECP_PROJECTS_TABLE_KEYS.Conformity_assessment_date]?: string
	[ECP_PROJECTS_TABLE_KEYS.City]?: string
	[ECP_PROJECTS_TABLE_KEYS.Street]?: string
	[ECP_PROJECTS_TABLE_KEYS.Hallway]?: string
	[ECP_PROJECTS_TABLE_KEYS.District]?: string
	[ECP_PROJECTS_TABLE_KEYS.Index]?: string
	[ECP_PROJECTS_TABLE_KEYS.Recent_activity_user]?: string
	[ECP_PROJECTS_TABLE_KEYS.DisabledAction]?: boolean
	[ECP_PROJECTS_TABLE_KEYS.ActiveReminders]?: boolean
}

interface ICPProjectsTableBaseShape {
	modelValue: number[]
	activeSort?: ICPTableHeadColActiveSort
	data: ICPProjectsTableItemTypes[]
	loading?: boolean
	hasActiveFilters?: boolean
	hiddenColumns?: ECP_PROJECTS_TABLE_KEYS[]
}

interface ICPProjectsTableInfiniteScroll {
	paginationMode: PaginationMode.InfiniteScroll
	page?: never
	pageCount?: never
	pageSize?: never
	pageSizeOptions?: never
	totalCount?: never
}

interface ICPProjectsTablePages {
	paginationMode: PaginationMode.Pages
	page: number
	pageCount: number
	pageSize: number
	totalCount: number
	pageSizeOptions?: number[]
}

export type ICPProjectsTablePropTypes = ICPProjectsTableBaseShape
	& (ICPProjectsTableInfiniteScroll | ICPProjectsTablePages)
